export default "__VITE_ASSET__od$HzY6B__"